import React from 'react';
import {  Button, Grid, Typography} from '@mui/material';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import nestle from "../../assets/images/nestle.png";
import logo from "../../assets/images/logo 1.png";


const CenteredImage = styled('img')({
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: '100%',
    maxHeight: '100%',
    borderRadius: "16px",
    mixBlendMode: "screen",
  });

const Login = ({handleLoginRedirect}) => {
  const handleLoginClick=()=>{
    handleLoginRedirect();
  };
  
  return (
    <Box sx={{ flexGrow: 1 }}>
    <Grid container spacing={2}>
      <Grid item xs={6} md={6} style={{ background: "linear-gradient(315deg, #054E9C 0%, #054E9C 75.03%)", display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CenteredImage src={nestle} alt="nestle" />
      </Grid>
      <Grid item xs={6} md={6} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', background: "#fff" }}>
        <img src={logo} alt="logo" style={{ width: "159.5px", height: "70px", marginBottom: "20px" }} />
        <Typography style={{ color: "#054E9C", fontFamily: "Poppins", fontSize: "22px", fontWeight: "500", marginBottom: "20px" }}>
          Integrated Fulfillment Command Centre
        </Typography>
        <Button onClick={handleLoginClick}variant="contained" style={{ width: "300px", background: "#054E9C", borderRadius: "8px" }}>Login</Button>
      </Grid>
    </Grid>
  </Box>
  );
};

export default Login;
